import React from 'react';

import { ServiceProductData } from '../../../../shared/types/graphql-types';

import './store-services.scss';

interface StoreServicesProps {
  servicesList: Array<ServiceProductData>;
}

export default function StoreServices(props: StoreServicesProps) {
  const { servicesList } = props;

  return (
    <ul data-testid={'mainlst'} styleName="service-list">
      {servicesList?.map((service, idx) => (
        <li
          data-testid={`lst-${idx}`}
          key={`ss-${idx}`}
          styleName="service-list-item"
        >
          {service.name}
        </li>
      ))}
    </ul>
  );
}
